<div class="formulario">
  <div class="myForm">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
      <!-- Fotos (estáticas) -->
      <div class="container mt-4">
        <div class="row">

          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 1</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,1)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(1)" type="button"><i
                      class="fa fa-camera"></i></button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(1)" type="button"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL">
              <p-image [src]="imgURL" [preview]="true" alt="Foto 1" width="250"></p-image>
              <i *ngIf="urlDeafaultImage == imgURL" class="fa fa-check-circle fa-3x"
                style="color: green; margin-left: 0.5em;" aria-hidden="true"></i>
              <div class="row text-center mt-2">
                <button id="archivo1" (click)="defaultImage($event, imgURL)" class="col-md center btn btn-dark"
                  type="button">
                  <i class="fa fa-bookmark-o"> &nbsp; Predeterminada</i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 2</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,2)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(2)" type="button"><i
                      class="fa fa-camera"></i></button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(2)" type="button"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL2">
              <p-image [src]="imgURL2" [preview]="true" alt="Foto 2" width="250"></p-image>
              <i *ngIf="urlDeafaultImage == imgURL2" class="fa fa-check-circle fa-3x"
                style="color: green; margin-left: 0.5em;" aria-hidden="true"></i>
              <div class="row text-center mt-2">
                <button id="archivo2" (click)="defaultImage($event, imgURL2)" class="col-md center btn btn-dark"
                  type="button">
                  <i class="fa fa-bookmark-o"> &nbsp; Predeterminada</i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 3</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,3)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(3)" type="button"><i
                      class="fa fa-camera"></i></button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(3)" type="button"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL3">
              <p-image [src]="imgURL3" [preview]="true" alt="Foto 3" width="250"></p-image>
              <i *ngIf="urlDeafaultImage == imgURL3" class="fa fa-check-circle fa-3x"
                style="color: green; margin-left: 0.5em;" aria-hidden="true"></i>
              <div class="row text-center mt-2">
                <button id="archivo3" (click)="defaultImage($event, imgURL3)" class="col-md center btn btn-dark"
                  type="button">
                  <i class="fa fa-bookmark-o"> &nbsp; Predeterminada</i>
                </button>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="form-group">
              <label>Foto 4</label>
              <div class="row">
                <div class="col-8">
                  <input type="file" class="form-control" style="height: 42px !important;"
                    (change)="uploadFile($event,4)">
                </div>
                <div class="col-1" style="text-align: right;">
                  <button class="btn btn-info" (click)="openCamera(4)" type="button"><i
                      class="fa fa-camera"></i></button>
                </div>
                <div class="col-1" style="text-align: right; margin-left: 0.5em;">
                  <button class="btn btn-danger" (click)="deleteImagen(4)" type="button"><i
                      class="fa fa-trash"></i></button>
                </div>
              </div>
            </div>
            <div class="form-group text-center" *ngIf="imgURL4">
              <p-image [src]="imgURL4" [preview]="true" alt="Foto 4" width="250"></p-image>
              <i *ngIf="urlDeafaultImage == imgURL4" class="fa fa-check-circle fa-3x"
                style="color: green; margin-left: 0.5em;" aria-hidden="true"></i>
              <div class="row text-center mt-2">
                <button id="archivo4" (click)="defaultImage($event, imgURL4)" class="col-md center btn btn-dark"
                  type="button">
                  <i class="fa fa-bookmark-o"> &nbsp; Predeterminada</i>
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Campos dinámicos -->
      <div class="row">
        @for (item of campos; track $index) {
        @if (!item.adminOnly || isAdmin) {
        <div [ngClass]="'col-lg-' + item.col">
          <div class="form-group" >
            <label>
              {{item.label}}
              @if (item.validation.toString().includes('required')) {
                <span class="font-bold text-red-600">*</span>
              } 
              <span> </span>
            </label>
            <input *ngIf="item.type == 'text'" class="form-control" type="text" [formControlName]="item.nombre">
            <input *ngIf="item.type == 'number'" class="form-control alider" type="number"
              [formControlName]="item.nombre">
            <textarea *ngIf="item.type == 'textarea'" class="form-control" [formControlName]="item.nombre"
              rows="3"></textarea>
            <p-calendar *ngIf="item.type == 'date'" [formControlName]="item.nombre" [locale]="es"
              dateFormat="dd/mm/yy"></p-calendar>
            <div *ngIf="item.type == 'switch'" class="input-group-text">
              <p-inputSwitch [formControlName]="item.nombre"></p-inputSwitch>
            </div>
            <app-generic-dropdown *ngIf="item.type == 'generic-dropdown'" [database]="'proveedores'"
              [item]="form.get(item.nombre).value" (selectItem)="setProveedor($event)">
            </app-generic-dropdown>
          </div>
        </div>
        }
        }
      </div>

      <br>
      <div class="botones">
        <button type="button" class="btn btn-warning" (click)="regresar()">
          <i class="fa fa-chevron-left" aria-hidden="true"></i> Volver
        </button>
        <button type="submit" class="btn btn-success" [disabled]="form.invalid || noGrabar">
          <i class="fa fa-save" aria-hidden="true"></i> Enviar
        </button>
      </div>

    </form>
  </div>
</div>
<p-toast [style]="{marginTop: '80px'}"></p-toast>

<p-dialog [visible]="showCamera">
  <div *ngIf="showCamera">
    <app-camera (sendImage)="getImage($event)" (closeCamera)="closeDialog($event)" [fileName]="fileName"
      [numberPhoto]="numberPhoto"></app-camera>
  </div>
</p-dialog>